// branch-visibility.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BranchVisibilityService {
  private branchVisibilitySubject = new Subject<{
    nodeId: string;
    branch: number;
    visible: boolean;
  }>();

  branchVisibility$ = this.branchVisibilitySubject.asObservable();

  setBranchVisibility(nodeId: string, branch: number, visible: boolean): void {
    this.branchVisibilitySubject.next({ nodeId, branch, visible });
  }
}
